interface Props {
  timestamp: number | string;
  /** Server-measured time to answer (metadata.answer_seconds), if any. */
  seconds?: number | null;
}

/** "4.2 s", "18 s", "1 min 05 s": precise while small, readable when not. */
export function formatAnswerSeconds(seconds: number): string {
  if (seconds < 10) return `${seconds.toFixed(1)} s`;
  if (seconds < 60) return `${Math.round(seconds)} s`;
  const total = Math.round(seconds);
  const s = total % 60;
  return `${Math.floor(total / 60)} min ${s < 10 ? '0' : ''}${s} s`;
}

const MessageTime = ({ timestamp, seconds }: Props) => {
  if (!timestamp) return null;
  const dateOptions: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit'
  };
  if (typeof timestamp === 'string' && !timestamp.endsWith('Z')) {
    timestamp = timestamp + 'Z';
  }
  const date = new Date(timestamp).toLocaleTimeString(undefined, dateOptions);
  const took =
    typeof seconds === 'number' && Number.isFinite(seconds) && seconds >= 0
      ? formatAnswerSeconds(seconds)
      : null;
  return (
    <p className="mt-[1px] text-[12px] leading-none">
      {date}
      {took ? (
        <span title="Time to answer" className="text-muted-foreground">
          {' · '}
          {took}
        </span>
      ) : null}
    </p>
  );
};

export { MessageTime };
